import  api  from "./api";

export const COUNTRY_CODES = {
    'Albania': 'AL',
    'Armenia': 'AM',
    'Azerbaijan': 'AZ',
    'Belarus': 'BY',
    'Bosnia and Herzegovina': 'BA',
    'Cyprus': 'CY',
    'Georgia': 'GE',
    'Kazakhstan': 'KZ',
    'Kosovo': 'XK',
    'Kyrgyzstan': 'KG',
    'Moldova': 'MD',
    'Montenegro': 'ME',
    'North Macedonia': 'MK',
    'Serbia': 'RS',
    'Tajikistan': 'TJ',
    'Turkey': 'TR',
    'Turkmenistan': 'TM',
    'Ukraine': 'UA',
    'Uzbekistan': 'UZ',
  };

export type Country = {
    _id: string,
    name: string,
    countryAdmin: string[],
    isTemplate?: boolean
}

const URL = 'countries/'
export const CountryService = {

    create: function(country: Country){
        return api.post(URL, country);
    },
    update: function(country: Country){
      return api.patch(URL+ country._id+'/', country)
    },
    delete: function(countryId: string){
        return api.delete(URL+ countryId+'/')
    },
    getById: function(countryId: string){
        return api.get(URL+ countryId+'/')
    },
    getAll: function(){
        return api.get(URL+'all/')
    },
}
